
import { getRegion } from '@/api/region';
import { iRegion } from '@/interface/region';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '@/utils/common';
import { Component, Mixins } from 'vue-property-decorator';
import Detail from './components/_Detail.vue';
@Component({
  components: { Detail },
})
export default class extends Mixins(PageQuery) {
  private tableList: iRegion[] = [];
  private id: number =0
  private visible = false;
  private type: string = '';
  //加载数据状态
  loading: boolean = false;
  row = {};
  async getTableList(sort_id: number) {
    try {
      this.loading = true;
      const res = await getRegion(sort_id);
      this.tableList = res.data.rows;
    } catch (ex) {
      toast('失败', 'error');
    } finally {
      this.loading = false;
    }
  }
  /**
   * 排序变化
   */
  sortChange(e: any) {
    const { order } = e.order;
    let sort_id = 0;
    if (order == 'ascending') {
      sort_id = 1;
    } else {
      sort_id = 2;
    }
    this.getTableList(sort_id);
  }
  showEdit(row: iRegion, type: string) {
    this.type = type;
    this.id = row.id;
    this.visible = true;

  }
  closeDialog() {
    this.visible = false;
  }
  handleSuccess()
  {
    this.closeDialog();
    this.getTableList(0);
  }

  mounted() {
    this.pageFn = this.getTableList;
    this.getTableList(0);
  }
}
